module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAIBAMAAAA7P9P/AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAbUExURUxpcf///////////////////////////////+WJFuQAAAAJdFJOUwCwwDoGqC8iCr+HnO8AAAA2SURBVAjXY2hjAIEMhkIDIMUszuCoDKSNRBhYhAwYmBUdGEACQC4DUMAYxAUKKImA9bCEArkAvDcFYmfR6/EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rkjt.png
// module id = 2YeC
// module chunks = 15